module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['cc-summary-outer', {
      collapsed: _vm.collapsed
    }]
  }, [_c('div', {
    staticClass: "cc-summary-pane"
  }, [_c('div', {
    staticClass: "cc-sp-collapse-btn",
    attrs: {
      "title": _vm.collapsed ? 'Expand panel' : 'Collapse panel'
    },
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.collapsed ? '▶' : '◀') + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-collapsed-strip"
  }, _vm._l((_vm.labels), function(label, i) {
    return _c('div', {
      key: 'icon-' + i,
      class: ['cc-sp-icon', _vm.stepStatus(i + 1)],
      attrs: {
        "title": (label + ": " + (_vm.stepStatus(i + 1)))
      }
    }, [_vm._v(_vm._s(i + 1))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-main-content"
  }, [_c('div', {
    staticClass: "cc-sp-hdr"
  }, [_c('div', {
    staticClass: "cc-sp-title"
  }, [_vm._v("Template Summary")]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-badge"
  }, [_vm._v(_vm._s(_vm.badge))])]), _vm._v(" "), _c('div', {
    staticClass: "tp-preview"
  }, [_c('div', {
    staticClass: "tp-preview-head"
  }, [_vm._v("Preview"), (_vm.summary.previewLanguage) ? _c('span', [_vm._v(" · " + _vm._s(_vm.summary.previewLanguage))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "tp-phone"
  }, [(_vm.summary.body || _vm.summary.header) ? _c('div', {
    staticClass: "tp-bubble"
  }, [(_vm.summary.header && _vm.summary.header.file) ? _c('media-preview', {
    attrs: {
      "compact": "",
      "show-caption": false,
      "format": _vm.summary.header.format,
      "media-id": _vm.summary.header.file.mediaId,
      "media-name": _vm.summary.header.file.mediaName || '',
      "country-id": _vm.summary.header.countryId,
      "language-id": _vm.summary.header.file.languageId
    }
  }) : (_vm.summary.header) ? _c('div', {
    staticClass: "tp-header-placeholder"
  }, [_c('i', {
    class: ['fa', _vm.headerIcon]
  }), _vm._v(" " + _vm._s(_vm.summary.header.format.toLowerCase()) + " header")]) : _vm._e(), _vm._v(" "), (_vm.summary.body) ? _c('p', {
    staticClass: "tp-body",
    domProps: {
      "innerHTML": _vm._s(_vm.bodyHtml)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tp-time"
  }, [_vm._v(_vm._s(_vm.now))])], 1) : _c('div', {
    staticClass: "tp-empty"
  }, [_vm._v("The message appears here once it's drafted.")]), _vm._v(" "), _vm._l((_vm.summary.buttons || []), function(button, i) {
    return _c('div', {
      key: i,
      staticClass: "tp-button"
    }, [(_vm.summary.buttonType === 'url_button') ? _c('i', {
      staticClass: "fa fa-external-link"
    }) : (_vm.summary.buttonType === 'phone_button') ? _c('i', {
      staticClass: "fa fa-phone"
    }) : _c('i', {
      staticClass: "fa fa-reply"
    }), _vm._v("\n            " + _vm._s(button) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(1)]
  }, [_vm._v("1")]), _vm._v(" Purpose")]), _vm._v(" "), (_vm.summary.purpose) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Type")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.purpose))])]) : _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not selected yet")])]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(2)]
  }, [_vm._v("2")]), _vm._v(" Where it lives")]), _vm._v(" "), (_vm.list(_vm.summary.customers)) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Customers")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.list(_vm.summary.customers)))])]) : _vm._e(), _vm._v(" "), (_vm.list(_vm.summary.countries)) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Countries")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.list(_vm.summary.countries)))])]) : _vm._e(), _vm._v(" "), (_vm.list(_vm.summary.accounts)) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("WhatsApp accounts")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.list(_vm.summary.accounts)))])]) : _vm._e(), _vm._v(" "), (_vm.summary.countries && _vm.summary.countries.length) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Journey")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.journey || 'None'))])]) : _vm._e(), _vm._v(" "), (_vm.list(_vm.summary.languages)) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Languages")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.list(_vm.summary.languages)))])]) : _vm._e(), _vm._v(" "), (!_vm.list(_vm.summary.countries) && !_vm.list(_vm.summary.customers)) ? _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not configured yet")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(3)]
  }, [_vm._v("3")]), _vm._v(" Content")]), _vm._v(" "), (_vm.summary.header) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Header")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.header.format.toLowerCase()) + _vm._s(_vm.summary.header.file ? (": " + (_vm.summary.header.file.mediaName)) : ''))])]) : _vm._e(), _vm._v(" "), (_vm.summary.buttons && _vm.summary.buttons.length) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Buttons")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.buttons.join(', ')))])]) : _vm._e(), _vm._v(" "), (_vm.summary.body) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Body")]), _c('span', {
    staticClass: "cc-sp-v",
    staticStyle: {
      "color": "#2E7D32"
    }
  }, [_vm._v("✓ Drafted")])]) : _vm._e(), _vm._v(" "), (!_vm.summary.body) ? _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not drafted yet")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(4)]
  }, [_vm._v("4")]), _vm._v(" Name & checks")]), _vm._v(" "), (_vm.summary.name) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Name")]), _c('span', {
    staticClass: "cc-sp-v tp-mono"
  }, [_vm._v(_vm._s(_vm.summary.name))])]) : _vm._e(), _vm._v(" "), (_vm.summary.category) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Category")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.category === 'MARKETING' ? 'Marketing' : 'Utility'))])]) : _vm._e(), _vm._v(" "), (_vm.summary.checks) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Checks")]), _c('span', {
    staticClass: "cc-sp-v",
    style: ({
      color: _vm.summary.checks === 'Passed' ? '#2E7D32' : '#b42318'
    })
  }, [_vm._v(_vm._s(_vm.summary.checks))])]) : _vm._e(), _vm._v(" "), (!_vm.summary.name && !_vm.summary.checks) ? _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not done yet")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "cc-sp-section"
  }, [_c('div', {
    staticClass: "cc-sp-lbl"
  }, [_c('span', {
    class: ['cc-sn', _vm.stepStatus(5)]
  }, [_vm._v("5")]), _vm._v(" Submit")]), _vm._v(" "), (_vm.summary.submitted) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("Sent")]), _c('span', {
    staticClass: "cc-sp-v"
  }, [_vm._v(_vm._s(_vm.summary.submitted.submitted) + " of " + _vm._s(_vm.summary.submitted.total))])]) : _vm._e(), _vm._v(" "), (_vm.summary.submitted && _vm.summary.submitted.failed) ? _c('div', {
    staticClass: "cc-sp-row"
  }, [_c('span', {
    staticClass: "cc-sp-k"
  }, [_vm._v("To retry")]), _c('span', {
    staticClass: "cc-sp-v",
    staticStyle: {
      "color": "#b42318"
    }
  }, [_vm._v(_vm._s(_vm.summary.submitted.failed))])]) : _vm._e(), _vm._v(" "), (!_vm.summary.submitted) ? _c('div', {
    staticClass: "cc-sp-empty"
  }, [_vm._v("Not submitted yet")]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7f8df016","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nudge-console/create-template/TemplateSummarySidebar.vue
// module id = /D1S
// module chunks = 1